import type { ChatDocumentDTO } from '@shared/schemas/chat';

const ATTACHMENT_URL_PREFIX = 'attachment://';
const ATTACHMENT_API_PATH = /\/api\/chat\/attachments\/([^/?#]+)$/;

/**
 * Pièce jointe du chat : son message garde `attachment://<id>` (ou l'URL de l'API, qui renvoie du
 * JSON), jamais une URL de fichier. `null` pour tout autre document.
 */
export function parseChatAttachmentId(document: ChatDocumentDTO): string | null {
  if (document.kind !== 'attachment' || !document.sourceUrl) {
    return null;
  }
  if (document.sourceUrl.startsWith(ATTACHMENT_URL_PREFIX)) {
    return document.sourceUrl.slice(ATTACHMENT_URL_PREFIX.length) || null;
  }
  const apiPath = ATTACHMENT_API_PATH.exec(document.sourceUrl.split('?')[0] ?? '');
  return apiPath?.[1] ? decodeURIComponent(apiPath[1]) : null;
}
